/**
 * Active time-on-page: time counts only while the tab is visible AND the user
 * was active within the last 15s (pointermove/keydown/scroll/click — pings
 * arrive from the single delegated listener each of those already has).
 * Segments fold lazily on read — no timers, no per-frame work.
 */
import { doc, now, on, visH } from './util';

const IDLE = 15_000;
let acc = 0; // closed active ms
let last = now(); // last user activity
let seg = doc.hidden ? -1 : last; // open segment start (-1 = none)
let maxS = 0;

/** Activity ping from the delegated listeners (throttled to ~1/s). */
export function ping(): void {
	const n = now();
	if (seg >= 0) {
		if (n - last < 1000) return;
		if (n - last > IDLE) {
			acc += last + IDLE - seg;
			seg = n;
		}
	} else if (!doc.hidden) seg = n;
	else return;
	last = n;
}

export function getTimeOnPage(): number {
	let t = acc;
	if (seg >= 0) t += Math.min(now(), last + IDLE) - seg;
	return Math.round(t);
}

export function getMaxScroll(): number {
	return Math.round(maxS);
}

/** Deepest scroll depth (0–100) seen on this page view; scrolling is activity. */
export function depth(p: number): void {
	if (p > maxS) maxS = p;
	ping();
}

export function resetPage(): void {
	acc = 0;
	last = now();
	seg = doc.hidden ? -1 : last;
	maxS = 0;
}

export function initActivity(): void {
	// keydown pings come from search.ts, clicks from clicks.ts, scroll from
	// scroll.ts — keeps ONE delegated listener per event type.
	on(doc, 'pointermove', ping);
}

// close the active segment when hidden, reopen when shown while still active
visH.push((hidden) => {
	const n = now();
	if (hidden) {
		if (seg >= 0) acc += Math.min(n, last + IDLE) - seg;
		seg = -1;
	} else if (n - last <= IDLE) seg = n;
});
